<div class="area-choice-wrapper">
    <div class="area-choice-header">
        <div class="area-choice-header--row">
            <div class="area-choice-header--title">Områdeoversikt</div>
        </div>
        <div class="area-choice-close" (click)="closeSidebar()"></div>
        <div class="area-choice-header--row">
            <input type="search" placeholder="Søk etter område, postnummer" [(ngModel)]="inputText" [formControl]="myControl" />
            @if (showCancelInput()) {
                <div class="cancelInput align-left" (mousedown)="resetText()"></div>
            }
        </div>
        @if (searchActive()) {
            <div class="area-choice-header--row">
                <div class="filter-dropdown-label">Vis</div>
                <ev-dropdown
                    class="filter-dropdown"
                    [items]="filterOptions()"
                    (onSelected)="setFilter($event)"
                    [minWidth]="'260'"
                    [selected]="selectedFilter()"
                    [right]="0"
                >
                </ev-dropdown>
            </div>
        }
    </div>
    @if (searchActive()) {
        <div class="area-choice-content searchmode">
            <ul class="area-list">
                @for (area of areas(); track area.areaId) {
                    <area-search-item [area]="area" (shiftSelect)="shiftSelectInSearch($event)"></area-search-item>
                } @empty {
                    <div class="display-info">
                        Fant ingen områder som passer søkeordene
                        @if (selectedFilter() !== AreaType.Undefined) {
                            for valgt områdetype
                        }
                    </div>
                }
            </ul>
        </div>
    } @else {
        <div class="area-choice-content">
            @if (navigatedPath.length) {
                <ev-button class="navigate-back" (click)="navigateBack()">
                    <span class="icon-navigate"></span>
                </ev-button>
            }
            <ol class="breadcrumbs">
                <li>
                    @if (navigatedPath.length) {
                        <span class="breadcrumb" (click)="navigateToRoot()">Fylker</span>
                        <span class="separator icon-navigate"></span>
                    } @else {
                        <span>Fylker</span>
                    }
                </li>
                @for (path of navigatedPath; track path.areaId; let last = $last) {
                    <li>
                        @if (last) {
                            <span>{{ path.name | titlecase }}</span>
                        } @else {
                            <span [class.breadcrumb]="!last" (click)="navigateToArea(path)">{{ path.name | titlecase }}</span>
                            <span class="separator icon-navigate"></span>
                        }
                    </li>
                }
            </ol>
            <div class="body">
                @if (this.currentAreaStructure()) {
                    <ul class="area-list">
                        @for (area of this.currentAreaStructure().areas; track area[0]?.areaType; let first = $first) {
                            @if (navigatedPath[navigatedPath.length - 1]?.areaType != null && area.length > 0) {
                                <ev-accordion
                                    [initExpanded]="navigatedPath.length < 2"
                                    [animationFast]="true"
                                    [accordionHeight]="32"
                                    [buttonSize]="18"
                                    [buttonTopMargin]="7"
                                >
                                    <div header>
                                        <div class="subheader">
                                            <h3 class="subheader-text">{{ getPathName(area[0]) }}</h3>
                                            <div class="subheader-counter">{{ area.length }}</div>
                                            <div class="subheader-toggle"></div>
                                        </div>
                                    </div>
                                    <div body>
                                        @for (a of area; track a.areaId) {
                                            <area-item
                                                [area]="a"
                                                [parent]="navigatedPath[navigatedPath.length - 1]"
                                                (shiftSelect)="shiftSelect($event)"
                                                (navigated)="navigateToChild($event)"
                                            ></area-item>
                                        }
                                    </div>
                                </ev-accordion>
                            } @else if (area.length > -1) {
                                <h3 class="category">{{ getPathName(area[0]) }}</h3>
                                @for (a of area; track a.areaId) {
                                    <area-item
                                        [area]="a"
                                        [parent]="navigatedPath[navigatedPath.length - 1]"
                                        (shiftSelect)="shiftSelect($event)"
                                        (navigated)="navigateToChild($event)"
                                    ></area-item>
                                }
                            }
                        }
                    </ul>
                }
            </div>
        </div>
    }
</div>
